"use client";




export default function Reviews() {
  const reviews = [
    {
      review:
        "We are owner of a multi-residential building of 84 apartments in Montreal, built in 1955. Many major reparations were necessary on our concrete balconies, this is when we hired Bishop Mercier to do the work. We have chosen Bishop Mercier for the professionalism and the know-how of the company. When an ownership is an asset we value, it is just normal to hire the proper companies to do the work.",
      name: "Antoine G.",
    },
    {
      review:
        "Excellent experience from first encounter last year. Accurate assessment of masonry and roof condition and how you would proceed. Work then proceeded efficiently and cleanly. Schedule was kept. A distinct aim to please and a flexibility was evident throughout. Open communication, professional and pleasant. Highly recommended. 5-stars.",
      name: "Louise L.",
    },
    {
      review:
        "This organization is first class. They are honest, reliable, and do fantastic work. I have done business with them in the past and have always been more than happy. I would highly recommend them.",
      name: "Mirella F.",
    },
    {
      review:
        "Jim Bishop and his team did an exceptional job. They are reliable, competent, honest and dependable. I do not hesitate in recommending Jim and his team as I was extremely satisfied. He is always there when you need him and is extremely helpful.",
      name: "Tony L.",
    },
    {
      review:
        "Best company I have hired…..job done on time and on budget. This is the first time I had a construction company do what they said they would do! I would hire them again.",
      name: "John B.",
    },
    {
      review:
        "They did some work on my house’s exterior, now it looks great. Good price, fast service. I highly recommend them.",
      name: "Nick N.",
    },
    {
      review:
        "They did a great job on our house. They came, they did the work from start to finish without any delays, and our home looks great. I recommend them 100%",
      name: "John F.",
    },
    {
      review:
        "I had work done to my apt. stress free. I was worried about my tenants complaining, and I was pleasantly surprised at how they kept everything clean and kept the noise to a minimum. They did a great job!",
      name: "S Lee",
    },
    {
      review:
        "They did our office and warehouse work and we couldn’t ask for more. Very punctual and very efficient!",
      name: "H Singh",
    },
  ];

  return (
    <section id="reviews" className="w-full py-12 px-5 md:px-8 lg:px-0">
      <div className="w-full mx-auto flex flex-col lg:flex-row justify-center items-center gap-10 lg:gap-16">
        {/* Content Section */}
        <div className="max-w-7xl w-full flex flex-col items-start">
          <span className="text-primary text-sm uppercase tracking-wider mb-2">
            Client Reviews
          </span>

          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-8 lg:mb-16">
            <span className="font-normal">Hear From Our Clients</span>
          </h2>

          {/* Masonry-style Reviews List */}
          <ul className="w-full columns-1 sm:columns-2 lg:columns-3 gap-6 space-y-6 [column-fill:_balance]">
            {reviews
              .filter((review) => !!review.name)
              .map((review, index) => (
                <li
                  key={index}
                  className="bg-card border p-6 rounded-lg mb-6 break-inside-avoid flex flex-col gap-2"
                >
                  <p className="text-foreground/80 text-base lg:text-lg leading-relaxed">
                    <span>{review.review}</span>
                  </p>
                  <span className="text-foreground font-bold">
                    <span>{review.name}</span>
                  </span>
                </li>
              ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
